import React, { useEffect, useState } from "react";
// 1. Import Helmet
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useLocation, useNavigate } from "react-router-dom";

const LegalDetailPage = ({ route }) => {
  // Initialize with an empty object for safe property access
  const [blog, setBlog] = useState({}); 
  const [blogList, setBlogList] = useState([]);

  const location = useLocation();
  const pageslug = location.search.split("=")[1];

  useEffect(() => {
    // Check if pageslug exists before fetching
    if (!pageslug) return;
    
    console.log("====================================");
    console.log(pageslug);
    console.log("====================================");
    fetch("https://services.steminorder.com/blog/getblogforwebsite", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pageslug: pageslug,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data, "blog data");
        // Ensure data is set to state
        setBlog(data); 
      })
      .catch((err) => {
        console.log(err.message);
        setBlog({}); // Clear blog data on error
      });
  }, [pageslug]); // Dependency on pageslug ensures fetch runs when URL parameter changes

  useEffect(() => {
    fetch("https://services.steminorder.com/admin/websitedata", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        let blogListTmp = data["bloglist"] ? data["bloglist"].splice(0, 4) : [];
        setBlogList(blogListTmp);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);
  
  // Dynamic Metadata Variables
  const PAGE_TITLE = blog.title ? `${blog.title} | Steminorder Legal Blog` : "Loading Blog Post...";
  const PAGE_DESCRIPTION = blog.shortdescription || "Read the latest legal insights and tips for the maritime and shipping industry from Steminorder.";
  const CANONICAL_URL = blog.pageslug ? `https://www.steminorder.com/legal-detail?s=${blog.pageslug}` : `https://www.steminorder.com/legal-detail?s=${pageslug}`;
  const OG_IMAGE_URL = blog.imagename || 'https://www.steminorder.com/images/default-blog.png'; // Fallback image

  return (
    <>
      {/* ============================================================
        REACT HELMET INTEGRATION (Dynamic Data)
        ============================================================
      */}
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={CANONICAL_URL} />

        {/* Open Graph Tags */}
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Steminorder" />
        <meta property="og:image" content={OG_IMAGE_URL} /> 
        {/* Article specific tags (optional but good practice) */}
        {blog.blogdate && <meta property="article:published_time" content={new Date(blog.blogdate).toISOString()} />}
        {blog.blogcategory && <meta property="article:section" content={blog.blogcategory} />}

        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>
      
      <Header />
      <div className="bg-legal-hero-pattern bg-center">
        <div className="container text-white p-5">
          <div className="row d-flex justify-center text-center">
            <div className="col-lg-5 col-sm-12">
              <h1 className="font-bold text-4xl text-center">
                Legal Assistance Tips
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row py-5">
          <div className="col-6">
            <a
              href="/legal-assistance"
              className="go-back-href text-link text-sm"
            >
              <i className="bi bi-chevron-left"></i> Back to the List
            </a>
          </div>
          <div className="col-6 text-right">
            <span className="text-right text-sm text-paragraph">
              Posted on {blog.blogdate}
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 offset-lg-2 col-sm-12">
            <h1 className="px-0 text-5xl font-bold text-heading">
              {blog.title}
            </h1>
          </div>
        </div>
        <div className="row m-3">
          <img
            className="img img-responsive rounded-4"
            src={blog.imagename}
            alt={blog.title} // Added alt tag for accessibility/SEO
          />
        </div>
        <div className="row">
          <div className="col-lg-8 offset-lg-2 col-sm-12">
            <div className="row">
              {/* Only render if body exists to prevent initial flicker/error */}
              {blog.body && <div dangerouslySetInnerHTML={{ __html: blog.body }}></div>} 
            </div>
          </div>
        </div>
        <div className="row py-8">
          <h2 className="text-3xl font-bold text-heading">What to read next</h2>
        </div>

        <div className="row mt-5 mb-5">
          {blogList.map((relatedBlog) => ( // Renamed map variable to relatedBlog for clarity
            <div className="col">
              <img
                className="img img-responsive rounded-4 pb-4"
                src={relatedBlog.imagename}
                alt={relatedBlog.title}
              />
              <span className="text-sm text-paragraph">{relatedBlog.blogdate}</span>
              <h4 className="py-3 text-2xl text-heading font-semibold">
                {relatedBlog.title}
              </h4>
              <p className="text-sm text-paragraph leading-loose">
                {relatedBlog.shortdescription}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default LegalDetailPage;